<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import utils from "@/common/utils.js";
export default {
  name: "App",
  methods: {
    ...mapMutations(["SET_TOKEN", "updateSubject"]),
  },
  created() {
    //当前科目
    this.updateSubject(utils.GetQueryValue("lesson"));
    // 导航栏信息
    this.$store.dispatch("getNav");
    // 用户信息
    this.$store.dispatch("getUsermsg");
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  min-width: 1200px;
}
a {
  color: #808695;
}
</style>



// WEBPACK FOOTER //
// src/App.vue